/**
 * IMPORTS
 */

import AxiosService from "@/infra/http/axios";

const changePasswordRepository = {
  /**
   * Define nova senha usando token recebido no email
   */
  async resetPassword(token: string, senha: string, novaSenha: string) {
    const Instance = await AxiosService.createAxiosInstance();

    const response = await Instance.post(
      "/users/redefinir-senha",
      {
        token,
        senha,
        nova_senha: novaSenha,
      },
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
        },
      }
    );

    return response.data;
  },
};

/**
 * EXPORTS
 */
export { changePasswordRepository };
